<script setup lang="ts">
import useExchangeRate from '@/views/Home/useExchangeRate';

defineProps<{
  value: number | null;
}>();

const { data: exchangeRate } = useExchangeRate();
</script>

<template>
  <div>
    <p v-if="exchangeRate && value != null">
      ~ ${{ (value * exchangeRate).toFixed(2) }}
    </p>
    <p v-else-if="!exchangeRate">~ $-.--</p>
    <p v-else>~ $0.00</p>
  </div>
</template>
